import { FC } from "react";
import { MemCommonMentionKind } from "@mem-labs/common-editor";
import { StyledMetadata } from "./combobox-list-item.style";

type Props = {
  kind: MemCommonMentionKind;
  metadata?: Record<string, unknown>;
  showMetadata?: boolean;
};

export const MDSComboboxListItemMetadata: FC<Props> = ({
  kind,
  metadata = {},
  showMetadata = true,
}) => {
  if (!showMetadata) return null;

  const isCollection = kind === MemCommonMentionKind.Collection;
  const isNote = kind === MemCommonMentionKind.Note;
  const noteCount = metadata.noteCount as number | undefined;
  const dateLabel = metadata.dateLabel as string | undefined;

  const metadataItems = [];

  // Show count for collections
  if (isCollection && typeof noteCount === "number") {
    const countText = noteCount === 1 ? "1 note" : `${noteCount} notes`;
    metadataItems.push(countText);
  }

  // Show date for notes
  if (isNote && dateLabel) {
    metadataItems.push(dateLabel);
  }

  if (metadataItems.length === 0) return null;

  return <StyledMetadata>{metadataItems.join(" • ")}</StyledMetadata>;
};
